module.exports = __webpack_public_path__ + "static/media/train_33.b829a731.jpg";